import { IMealtime, ICategory } from 'src/types/mealtimes.types';

export const getMealtimesCategoryIds = (mealtimes: IMealtime[]) =>
  mealtimes.map((mealtime: IMealtime) => mealtime.categories.map((category: ICategory) => category.category_id)).flat();
